import { Routes } from '@angular/router';
import {
  BreadCrumbRouteConfig,
  RenderInterfaceGuard,
  Utils
} from 'viggo-sistemas-core-web';

export const routesAdminProduto: Routes = [
  {
    path: 'entrada',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@modules/entrada/entrada.module').then(m => m.EntradaModule),
    data: {
      breadcrumbMenu: Utils.getBreadcrumbMenu('SUPRIMENTOS'),
      module: 'PROD_ENTRADA',
      breadcrumb: {
        label: 'Entrada',
        icon: 'mdi mdi-archive-arrow-down-outline'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'saida',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@modules/saida/saida.module').then(m => m.SaidaModule),
    data: {
      breadcrumbMenu: Utils.getBreadcrumbMenu('SUPRIMENTOS'),
      module: 'PROD_SAIDA',
      breadcrumb: {
        label: 'Saída',
        icon: 'mdi mdi-archive-arrow-up-outline'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'grupos',
    canActivate: [RenderInterfaceGuard],
    data: {
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES', 'PRODUTO'),
      module: 'PROD_GRUPO',
      preload: false,
      breadcrumb: { label: 'Grupo', icon: 'mdi mdi-shape-outline' }
    },
    loadChildren: () =>
      import('@app/modules/grupo/grupo.module').then(m => m.GrupoModule)
  },
  {
    path: 'produtos',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'PRODUTO',
      preload: false,
      breadcrumb: { label: 'Produto', icon: 'pi pi-fw pi-box' }
    },
    loadChildren: () =>
      import('@app/modules/produto/produto.module').then(m => m.ProdutoModule)
  },
  {
    path: 'tabela-preco',
    canActivate: [RenderInterfaceGuard],
    data: {
      breadcrumbMenu: Utils.getBreadcrumbMenu('CADASTROS'),
      module: 'PROD_TABELA_PRECO',
      preload: false,
      breadcrumb: {
        label: 'Tabela de preço',
        icon: 'mdi mdi-file-table-box-multiple-outline'
      }
    },
    loadChildren: () =>
      import('@app/modules/tabelapreco/tabelapreco.module').then(
        m => m.TabelaPrecoModule
      )
  },
  {
    path: 'unidades',
    canActivate: [RenderInterfaceGuard],
    data: {
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES', 'PRODUTO'),
      module: 'PROD_UNIDADE',
      preload: false,
      breadcrumb: { label: 'Unidade', icon: 'mdi mdi-sitemap' }
    },
    loadChildren: () =>
      import('@app/modules/unidade/unidade.module').then(m => m.UnidadeModule)
  },
  {
    path: 'catalogo-produto',
    canActivate: [RenderInterfaceGuard],
    data: {
      breadcrumbMenu: Utils.getBreadcrumbMenu('CADASTROS'),
      module: 'PROD_CATALOGO',
      preload: false,
      breadcrumb: {
        label: 'Catálogo de produtos',
        icon: 'mdi mdi-notebook'
      }
    },
    loadChildren: () =>
      import(
        '@app/modules/catalogo-produto-privado/catalogo-produto-privado.module'
      ).then(m => m.CatalogoProdutoPrivadoModule)
  },
  {
    path: 'variacao_produtos',
    canActivate: [RenderInterfaceGuard],
    data: {
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES', 'PRODUTO'),
      module: 'PROD_VARIACAO_PRODUTO',
      preload: false,
      breadcrumb: {
        label: 'Variações de produto',
        icon: 'mdi mdi-vector-difference-ba'
      }
    },
    loadChildren: () =>
      import('@app/modules/variacao-produtos/variacao-produtos.model').then(
        m => m.VariacaoProdutosModule
      )
  }
];
